import { useI18n } from 'vue-i18n';
import NavigationHelper from '@/util/NavigationHelper';
import { useRouter } from 'vue-router';
import { Forms } from '@/enums/Forms';
import UserController from '@/controllers/UserController';
import ValidationRules from '@/util/ValidationRules';
import { Ref, ref } from 'vue';
import PageHelper from '@/util/PageHelper';
import { AuthResponseStatus } from '@/enums/AuthResponseStatus';
import PolteqButton from '@/components/PolteqButton/PolteqButton.vue';
import PolteqTextField from '@/components/PolteqTextField/PolteqTextField.vue';
import { VForm } from 'vuetify/components';

export default {
  name: 'SignInForm',
  components: {
    PolteqButton,
    PolteqTextField
  },
  computed: {
    NavigationHelper() {
      return NavigationHelper;
    }
  },
  setup() {
    const i18n = useI18n();
    const router = useRouter();
    const rules = ValidationRules.getRules();
    const forgotPasswordForm = ref() as Ref<VForm>;
    const resetPassword = async (emailaddress: string) => {
      await forgotPasswordForm.value.validate();
      if (forgotPasswordForm.value.isValid) {
        const response = await UserController.forgotPassword(emailaddress);
        PageHelper.setNotificationMessage(response);
        if (response.status === AuthResponseStatus.SUCCESS) {
          await NavigationHelper.openForm(router, Forms.SIGN_IN);
        }
      }
    };
    return {
      i18n,
      router,
      Forms,
      rules,
      forgotPasswordForm,
      resetPassword
    };
  },
  data() {
    return {
      emailaddress: ''
    };
  }
};
